import React from "react";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { StyledFieldLabel } from "@iventis/styles";
import { TextField } from "@mui/material";
import { Content } from "@iventis/translations";
import { FileUploadComponent } from "@iventis/components/src/upload-file";
import { SitemapVersionLevelStatus } from "@iventis/domain-model/model/sitemapVersionLevelStatus";
import { SitemapVersionLevelMbtiles } from "./sitemap-types";

export const SitemapVersionLevelMbTilesForm = ({
    sitemapVersionLevel,
    setSitemapVersionLevel,
}: {
    sitemapVersionLevel: SitemapVersionLevelMbtiles;
    setSitemapVersionLevel: (sitemapVersionLevel: SitemapVersionLevelMbtiles) => void;
}) => {
    const translate = useIventisTranslate();

    return (
        <>
            <div>
                <StyledFieldLabel>{translate(Content.map9.sitemapVersion.perimeter)}</StyledFieldLabel>
                <TextField
                    inputProps={{ "data-testid": "sitemap-level-perimiter-input" }}
                    variant="outlined"
                    className="perimeter-input"
                    value={sitemapVersionLevel.perimeter ?? ""}
                    onChange={({ target: { value } }) => setSitemapVersionLevel({ ...sitemapVersionLevel, perimeter: value })}
                />
            </div>
            <div>
                <StyledFieldLabel>{translate(Content.sitemaps.sitemapVersion.tiles)}</StyledFieldLabel>
                <FileUploadComponent
                    dataTestIdButton="sitemap-level-tiles-button"
                    dataTestIdInput="sitemap-level-tiles-input"
                    uploadFile={(file: File) => {
                        setSitemapVersionLevel({ ...sitemapVersionLevel, status: SitemapVersionLevelStatus.Uploading, mbtiles: file });
                    }}
                    uploadButtonText={translate(Content.sitemaps.sitemapVersion.upload_tiles)}
                    removeRequested={() => setSitemapVersionLevel({ ...sitemapVersionLevel, mbtiles: undefined })}
                    loading={false}
                    removeImageText={translate(Content.sitemaps.sitemapVersion.remove_tiles)}
                    persistFileSelectInput
                    fileName={sitemapVersionLevel.mbtiles?.name}
                />
            </div>
            <div>
                <StyledFieldLabel>{translate(Content.sitemaps.sitemapVersion.style)}</StyledFieldLabel>
                <FileUploadComponent
                    dataTestIdButton="sitemap-level-style-button"
                    dataTestIdInput="sitemap-level-style-input"
                    uploadFile={(file: File) => {
                        setSitemapVersionLevel({ ...sitemapVersionLevel, style: file });
                    }}
                    uploadButtonText={translate(Content.sitemaps.sitemapVersion.upload_style)}
                    removeRequested={() => setSitemapVersionLevel({ ...sitemapVersionLevel, style: undefined })}
                    loading={false}
                    removeImageText={translate(Content.sitemaps.sitemapVersion.remove_tiles)}
                    persistFileSelectInput
                    fileName={sitemapVersionLevel.style?.name}
                />
            </div>
        </>
    );
};
